function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M68.314,204.423c1.787,3.091,5.086,4.994,8.657,4.994h109.587c3.57,0,6.869-1.903,8.657-4.994l54.774-94.71 c1.792-3.097,1.792-6.916,0-10.013L195.214,4.994C193.427,1.903,190.127,0,186.557,0H76.971c-3.57,0-6.869,1.903-8.657,4.994 L13.543,99.7c-1.791,3.097-1.791,6.915,0,10.013L68.314,204.423z M82.739,20h98.05l48.991,84.707l-48.991,84.71h-98.05 l-48.987-84.71L82.739,20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466.456,234.994l-54.771-94.707c-1.787-3.09-5.086-4.994-8.656-4.994H293.441c-3.57,0-6.869,1.903-8.656,4.994 l-54.775,94.707c-1.792,3.097-1.792,6.915,0,10.013l54.775,94.707c1.787,3.09,5.086,4.994,8.656,4.994h109.588 c3.57,0,6.869-1.903,8.656-4.994l54.771-94.707C468.248,241.909,468.248,238.091,466.456,234.994z M397.261,324.707H299.21 L250.219,240l48.991-84.706h98.051L446.248,240L397.261,324.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M195.214,275.577c-1.788-3.09-5.087-4.994-8.657-4.994H76.971c-3.57,0-6.87,1.903-8.657,4.994l-54.771,94.71 c-1.791,3.097-1.791,6.915,0,10.013l54.771,94.706c1.788,3.09,5.087,4.994,8.657,4.994h109.587c3.57,0,6.869-1.903,8.657-4.994 l54.774-94.706c1.792-3.097,1.792-6.915,0-10.013L195.214,275.577z M180.789,460h-98.05l-48.987-84.706l48.987-84.711h98.05 l48.991,84.711L180.789,460z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.468,40.241c-4.779-2.766-10.897-1.136-13.665,3.644l-37.21,64.272c-2.767,4.779-1.136,10.897,3.644,13.665 c1.578,0.914,3.3,1.347,5.001,1.347c3.452,0,6.81-1.789,8.664-4.991l37.21-64.272C119.879,49.126,118.247,43.008,113.468,40.241z "
}), /*#__PURE__*/React.createElement("path", {
  d: "M311.178,199.417c0,5.523,4.478,10,10,10h81.178c5.522,0,10-4.477,10-10s-4.478-10-10-10h-81.178 C315.655,189.417,311.178,193.894,311.178,199.417z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.399,426.704c-2.751,4.789-1.1,10.901,3.689,13.652c1.57,0.902,3.282,1.331,4.972,1.331 c3.463,0,6.831-1.801,8.68-5.02l30.442-52.985c2.751-4.789,1.1-10.901-3.689-13.652c-4.789-2.752-10.901-1.1-13.652,3.689 L149.399,426.704z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgBiology = function SvgBiology(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBiology, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/biology.cad5f4a5.svg";
export { ForwardRef as ReactComponent };